/**
 * @param url - исходный URL для нормализации
 * @param options - опции нормализации
 * @param options.baseUrl - базовый URL, к которому будет добавлен путь (например, 'https://example.com/teams/')
 * @param options.addProtocol - добавлять ли протокол https:// если его нет (по умолчанию true)
 * @returns нормализованный URL или исходное значение, если оно пустое
 */
export const normalizeUrl = (
    url: string | null | undefined,
    options?: {
        baseUrl?: string;
        addProtocol?: boolean;
    }
): string => {
    if (!url) {
        return url || '';
    }

    const { baseUrl, addProtocol = true } = options || {};

    let normalizedUrl = url.trim().replace(/^\s+|\s+$/g, '');

    if (!normalizedUrl) {
        return normalizedUrl;
    }

    const hasProtocol = /^https?:\/\//.test(normalizedUrl);

    if (hasProtocol && !baseUrl) {
        return normalizedUrl;
    }

    if (hasProtocol && baseUrl) {
        if (normalizedUrl.startsWith(baseUrl)) {
            return normalizedUrl;
        }
        normalizedUrl = normalizedUrl.replace(/^https?:\/\//, '');
    }

    if (baseUrl) {
        const cleanPath = normalizedUrl.replace(/^https?:\/\//, '').replace(/^\//, '');
        const isProtocolOnly = /^https?:\/\/$/.test(baseUrl);
        
        if (isProtocolOnly) {
            return `${baseUrl}${cleanPath}`;
        }
        const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
        
        return `${cleanBaseUrl}/${cleanPath}`;
    }

    if (addProtocol && !hasProtocol) {
        return `https://${normalizedUrl}`;
    }

    return normalizedUrl;
};

/**
 * @param url - исходный URL для нормализации
 * @param options - опции нормализации
 * @param options.baseUrl - базовый URL, к которому будет добавлен путь (например, 'https://example.com/teams/')
 * @param options.addProtocol - добавлять ли протокол https:// если его нет (по умолчанию true)
 * @returns нормализованный URL или исходное значение, если оно пустое
 */
export const normalizeUrl = (
    url: string | null | undefined,
    options?: {
        baseUrl?: string;
        addProtocol?: boolean;
    }
): string => {
    if (!url) {
        return url || '';
    }

    const { baseUrl, addProtocol = true } = options || {};

    let normalizedUrl = url.trim().replace(/^\s+|\s+$/g, '');

    if (!normalizedUrl) {
        return normalizedUrl;
    }

    const hasProtocol = /^https?:\/\//.test(normalizedUrl);

    if (hasProtocol && !baseUrl) {
        return normalizedUrl;
    }

    if (hasProtocol && baseUrl) {
        if (normalizedUrl.startsWith(baseUrl)) {
            return normalizedUrl;
        }
        normalizedUrl = normalizedUrl.replace(/^https?:\/\//, '');
    }

    if (baseUrl) {
        const cleanPath = normalizedUrl.replace(/^https?:\/\//, '').replace(/^\//, '');
        const isProtocolOnly = /^https?:\/\/$/.test(baseUrl);
        
        if (isProtocolOnly) {
            return `${baseUrl}${cleanPath}`;
        }
        const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
        
        return `${cleanBaseUrl}/${cleanPath}`;
    }

    if (addProtocol && !hasProtocol) {
        return `https://${normalizedUrl}`;
    }

    return normalizedUrl;
};

